import React from "react";

const ShareIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={14}
      height={14}
      viewBox="0 0 14 14"
      fill="none"
    >
      <g clipPath="url(#clip0_353_3984)">
        <path
          d="M0 13.4163V9.33294C0.001544 7.94103 0.555163 6.60657 1.53939 5.62234C2.52363 4.63811 3.85809 4.08449 5.25 4.08295H8.0675V3.15778C8.06755 2.92707 8.136 2.70156 8.2642 2.50975C8.3924 2.31793 8.57459 2.16844 8.78774 2.08016C9.00089 1.99188 9.23542 1.96877 9.4617 2.01377C9.68798 2.05876 9.89584 2.16984 10.059 2.33295L13.489 5.76236C13.8171 6.09053 14.0014 6.53557 14.0014 6.99961C14.0014 7.46364 13.8171 7.90868 13.489 8.23686L10.059 11.6663C9.89584 11.8294 9.68798 11.9405 9.4617 11.9854C9.23542 12.0304 9.00089 12.0073 8.78774 11.9191C8.57459 11.8308 8.3924 11.6813 8.2642 11.4895C8.136 11.2977 8.06755 11.0721 8.0675 10.8414V9.91627H4.66667C3.73869 9.9172 2.84899 10.2862 2.19282 10.9424C1.53664 11.5986 1.16759 12.4883 1.16667 13.4163C1.16667 13.571 1.10521 13.7193 0.995812 13.8287C0.886416 13.9381 0.738043 13.9996 0.583333 13.9996C0.428624 13.9996 0.280251 13.9381 0.170854 13.8287C0.0614582 13.7193 0 13.571 0 13.4163ZM9.23417 4.66628C9.23417 4.82099 9.17271 4.96936 9.06331 5.07876C8.95392 5.18815 8.80554 5.24961 8.65083 5.24961H5.25C4.16741 5.25085 3.12952 5.68145 2.36401 6.44695C1.59851 7.21246 1.1679 8.25035 1.16667 9.33294V10.3328C1.60391 9.83515 2.14229 9.43654 2.74584 9.16353C3.34939 8.89052 4.00424 8.74941 4.66667 8.74961H8.65083C8.80554 8.74961 8.95392 8.81106 9.06331 8.92046C9.17271 9.02986 9.23417 9.17823 9.23417 9.33294V10.8414L12.6636 7.41202C12.7729 7.30263 12.8344 7.15429 12.8344 6.99961C12.8344 6.84493 12.7729 6.69658 12.6636 6.58719L9.23417 3.15778V4.66628Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_353_3984">
          <rect width={14} height={14} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ShareIcon;
